import { render, staticRenderFns } from "./AssetStakingCategorization.vue?vue&type=template&id=7204e68c&"
import script from "./AssetStakingCategorization.vue?vue&type=script&lang=js&"
export * from "./AssetStakingCategorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports